module.exports = __webpack_public_path__ + "img/1.018cd63a.png";